export default class Grid {
    
    constructor(selector, userOptions = {}) {
        this.selector = document.querySelectorAll(selector)[0];

        const defaultOptions = {
            verticalSpacing: 8,

        }

        this.options = Object.assign(defaultOptions, userOptions);

        document.addEventListener('keydown', (e) => {
            this.keyPress(e);
        });
    }

    init() {
        this.buildGrid();
    }

    keyPress(e) {
        var evtobj = window.event? event : e
        if (evtobj.keyCode == 71 && evtobj.ctrlKey) {
            this.selector.classList.toggle("is-visible");
            document.querySelectorAll('body')[0].classList.toggle("debug");
        }
    }

    buildGrid() {
        var body = document.body,
        html = document.documentElement;
        var viewportHeight = Math.max( body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight );
        // const viewportHeight = window.innerHeight;
        const num_lines = Math.ceil(viewportHeight / this.options.verticalSpacing);
        const container = this.selector.querySelectorAll('.baselineGrid')[0];

        for (let index = 0; index < num_lines; index++) {
            var tag = document.createElement("div");
            container.appendChild(tag);
        }
    }

    
}